// Product image paths and alt text.
//
// Alt text does more for image search than the filename does, and it is the
// part nobody wants to type 126 times — so it is generated from the catalogue.
// Each slot gets a different description: seven identical alt tags on one page
// are worse than none, because Google reads them as boilerplate.

export const IMAGE_SLOTS = [
  { key: 'front', label: 'Front view' },
  { key: 'features', label: 'Features' },
  { key: 'warranty', label: 'Warranty' },
  { key: 'filters', label: 'Filtration' },
  { key: 'energy-label', label: 'Energy label' },
  { key: 'remote', label: 'Remote' },
  { key: 'outdoor-unit', label: 'Outdoor unit' },
];

export const imagePath = (model, slot) =>
  `/products/${model.imageCode}/${model.imageBase}-${slot}.webp`;

// The indoor code that names the folder, uppercased for display.
const code = (model) => model.imageCode.toUpperCase();

export function imageAlt(model, slot) {
  const name = `Daikin ${model.soldAs} Ton ${model.stars} Star ${model.inverter ? 'Inverter' : 'Fixed Speed'} Split AC`;
  const feats = (model.features || []).slice(0, 3).join(', ');

  switch (slot) {
    case 'front':
      return `${name} ${code(model)} front view`;
    case 'features':
      return `Daikin ${code(model)} ${model.soldAs} ton AC features${feats ? ` — ${feats}` : ''}`;
    case 'warranty':
      return `Daikin ${code(model)} warranty — 10 years compressor, 5 years PCB, 1 year comprehensive`;
    case 'filters':
      return `Daikin ${code(model)} filtration and Hepta Sense with filter clean indicator`;
    case 'energy-label':
      return `Daikin ${code(model)} BEE ${model.stars} star energy label, ISEER ${model.iseer}`;
    case 'remote':
      return `Daikin ${code(model)} remote control with Powerful, Econo and timer modes`;
    case 'outdoor-unit':
      return `Daikin ${code(model)} outdoor unit with 100% copper coil and R32 refrigerant`;
    default:
      return name;
  }
}

export const galleryFor = (model) =>
  IMAGE_SLOTS.map((s) => ({
    slot: s.key,
    label: s.label,
    src: imagePath(model, s.key),
    alt: imageAlt(model, s.key),
  }));

// Inline SVG so a missing file never fires a second network request.
export const IMG_FALLBACK =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 140'%3E%3Crect fill='%23f1f5f9' width='200' height='140'/%3E%3Crect x='40' y='52' width='120' height='30' rx='6' fill='none' stroke='%23cbd5e1' stroke-width='2'/%3E%3Cline x1='52' y1='72' x2='148' y2='72' stroke='%23cbd5e1' stroke-width='2'/%3E%3C/svg%3E";